import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { UserPermission } from '../models/user-permission.model';
import { ResponseUtil } from '../../shared/utils/response-util';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { CustomerConfig } from 'app/auth/models/Customer-config';

@Injectable()
export class AuthenticationHttpService {
  private readonly loginURL: string = this.environment.baseUrl + '/api/auth/login';
  private readonly permissionURL: string = this.environment.baseUrl + '/api/auth/permissions';
  private readonly refreshURL: string = this.environment.baseUrl + '/api/auth/refresh';
  private readonly updateIataURL: string = this.environment.baseUrl + '/api/auth/update/iata';
  private readonly clientContactEditableURL: string = this.environment.baseUrl + '/api/auth/customer/edit';

  constructor(private http: HttpClient,
              private environment: EnvironmentConfiguration) {
  }

  login(username: string, password: string): Observable<UserPermission> {
    const loginPayload = { 'userId': username, 'password': password };

    return this.http.post(this.loginURL, loginPayload)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getPermissions(token: string, defaultArciata: string): Observable<UserPermission> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    let options = null;

    if (defaultArciata == null || defaultArciata.length === 0) {
      options = {
        headers: headers
      }; // Create a request option
    } else {
      options = {
        headers: headers,
        params: new HttpParams().set('arcIata', defaultArciata)
      }; // Create a request option
    }

    return this.http.get(this.permissionURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  refreshPermissions(token: string): Observable<UserPermission> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    const options = {
      headers: headers
    }; // Create a request option

    return this.http.get(this.refreshURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  updateIataFromToken(token: string, newArciata: string): Observable<UserPermission> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    let options = {
      headers: headers,
      params: new HttpParams().set('arcIata', newArciata)
    }; // Create a request option

    return this.http.get(this.updateIataURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  retrieveAgencies(token: string): Observable<MultiAgency[]> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    let options = {
      headers: headers
    }; // Create a request option

    return this.http.get(this.environment.baseUrl + '/api/lookup/agencies/token', options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  isClientContactEditable(token: string): Observable<CustomerConfig> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    let options = {
      headers: headers
    }; // Create a request option

    return this.http.get(this.clientContactEditableURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/permission/services/authentication.http.service.ts